import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Eye } from 'lucide-react';
export function LiveViewerFloat() {
  const [count, setCount] = useState(Math.floor(Math.random() * 15) + 12);
  const [visible, setVisible] = useState(false);
  // Show only when user scrolls down
  useEffect(() => {
    let lastScrollY = 0;
    const handleScroll = () => {
      const currentY = window.scrollY;
      if (currentY > 200 && currentY > lastScrollY) {
        setVisible(true);
      } else if (currentY < 100) {
        setVisible(false);
      }
      lastScrollY = currentY;
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Randomly change count
  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prev => {
        const change = Math.floor(Math.random() * 5) - 2;
        return Math.max(8, Math.min(35, prev + change));
      });
    }, 4000 + Math.random() * 3000);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-31">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-6 inset-x-0 z-40 flex justify-center px-4 pointer-events-none" data-id="element-32">
          <div className="pointer-events-auto bg-[#111b21]/90 backdrop-blur-md border border-white/10 rounded-full px-4 py-2 shadow-[0_4px_20px_rgba(0,0,0,0.4)] flex items-center gap-2.5" data-id="element-33">
            <span className="relative flex h-2 w-2 shrink-0" data-id="element-34">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-35" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-36" />
            </span>
            <Eye className="w-3.5 h-3.5 text-gray-400 shrink-0" data-id="element-37" />
            <span className="text-xs text-gray-300 whitespace-nowrap" data-id="element-38">
              <span className="text-white font-bold" data-id="element-39">{count}</span> personas
              viendo ahora
            </span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}